import React from "react";
import { Link } from "../../polyrouter";
import { handleNullFields } from "../../utilities/stringUtils";
import { AllQueryParam } from "../../polyrouter/allQueryParams";

const ShimmerLink: React.FC<{
  loading: boolean;
  hasData: boolean;
  link: string;
  display?: string | null;
  persist?: Array<AllQueryParam>;
}> = ({ loading, persist, hasData, link, display }) => {
  return !loading && hasData ? (
    <Link persist={persist} to={link}>
      {handleNullFields(display)}
    </Link>
  ) : (
    <div
      data-testid={loading && "shimmer"}
      className={loading ? "shimmer" : "greyed-out"}
    >
      {`${handleNullFields(display)} ${loading ? "" : "*"}`}
    </div>
  );
};

export default ShimmerLink;
